/**
 * Category for user-scoped features created at runtime via the scoped/user
 * features tables. No static FeatureDef entries live here today - the category
 * is registered so the DB sync migration ensures the row exists.
 */
export const UserMetadata = { id: 12, name: 'User Metadata' };
export const userMetadataFeatures = [];
